<template>
    <v-container fluid>
        <v-row>
            <!-- ========================================================= -->
            <!-- EQUIPAMENTO INTERNO                                      -->
            <!-- ========================================================= -->
            <v-col cols="12">
                <v-card class="elevation-0">
                    <v-card-title class="warning white--text">
                        <span>Equipamento Interno</span>

                        <v-spacer />

                        <v-btn
                            small
                            color="primary"
                            dark
                            :loading="loadingCatalog && !catalogLoaded"
                            @click="openDialog('internal')"
                        >
                            <v-icon left small>
                                mdi-plus
                            </v-icon>

                            Adicionar
                        </v-btn>
                    </v-card-title>

                    <v-card-text class="pa-0">
                        <v-simple-table>
                            <template v-slot:default>
                                <thead>
                                    <tr>
                                        <th>Equipamento</th>
                                        <th>Frente Obra</th>
                                        <th>Classe</th>
                                        <th>HS / dia</th>
                                        <th>HO</th>
                                        <th>HP</th>
                                        <th>Local</th>
                                        <th class="text-right">
                                            Opções
                                        </th>
                                    </tr>
                                </thead>

                                <tbody>
                                    <tr
                                        v-for="(item, index) in paginatedEquipamentosInternos"
                                        :key="equipmentRowKey(item, index, 'internal')"
                                    >
                                        <td>
                                            {{ equipmentText(item) }}
                                        </td>

                                        <td>
                                            {{ frenteText(item) }}
                                        </td>

                                        <td>
                                            {{ classeText(item) }}
                                        </td>

                                        <td>
                                            {{ valueOrDash(item.hs) }}
                                        </td>

                                        <td>
                                            {{ valueOrDash(item.ho) }}
                                        </td>

                                        <td>
                                            {{ valueOrDash(item.hp) }}
                                        </td>

                                        <td>
                                            {{ valueOrDash(item.local) }}
                                        </td>

                                        <td class="text-right text-no-wrap">
                                            <v-btn
                                                icon
                                                small
                                                color="primary"
                                                @click="editInternal(index)"
                                            >
                                                <v-icon small>
                                                    mdi-pencil
                                                </v-icon>
                                            </v-btn>

                                            <v-btn
                                                icon
                                                small
                                                color="error"
                                                @click="deleteInternal(index)"
                                            >
                                                <v-icon small>
                                                    mdi-delete
                                                </v-icon>
                                            </v-btn>
                                        </td>
                                    </tr>

                                    <tr
                                        v-if="paginatedEquipamentosInternos.length === 0"
                                    >
                                        <td
                                            colspan="8"
                                            class="text-center grey--text py-6"
                                        >
                                            Sem equipamentos.
                                        </td>
                                    </tr>
                                </tbody>
                            </template>
                        </v-simple-table>

                        <div
                            v-if="equipInternoTotalPages > 1"
                            class="d-flex align-center justify-center py-4"
                        >
                            <v-btn
                                fab
                                x-small
                                color="primary"
                                dark
                                :disabled="equipInternoPage <= 1"
                                @click="equipInternoPage--"
                            >
                                <v-icon small>
                                    mdi-chevron-left
                                </v-icon>
                            </v-btn>

                            <span class="mx-4">
                                {{ equipInternoPage }} /
                                {{ equipInternoTotalPages }}
                            </span>

                            <v-btn
                                fab
                                x-small
                                color="primary"
                                dark
                                :disabled="equipInternoPage >= equipInternoTotalPages"
                                @click="equipInternoPage++"
                            >
                                <v-icon small>
                                    mdi-chevron-right
                                </v-icon>
                            </v-btn>
                        </div>
                    </v-card-text>
                </v-card>
            </v-col>

            <!-- ========================================================= -->
            <!-- EQUIPAMENTO EXTERNO                                      -->
            <!-- ========================================================= -->
            <v-col cols="12">
                <v-card class="elevation-0">
                    <v-card-title class="warning white--text">
                        <span>Equipamento Externo</span>

                        <v-spacer />

                        <v-btn
                            small
                            color="primary"
                            dark
                            :loading="loadingCatalog && !catalogLoaded"
                            @click="openDialog('external')"
                        >
                            <v-icon left small>
                                mdi-plus
                            </v-icon>

                            Adicionar
                        </v-btn>
                    </v-card-title>

                    <v-card-text class="pa-0">
                        <v-simple-table>
                            <template v-slot:default>
                                <thead>
                                    <tr>
                                        <th>Equipamento</th>
                                        <th>Frente Obra</th>
                                        <th>Classe</th>
                                        <th>HS / dia</th>
                                        <th>HO</th>
                                        <th>HP</th>
                                        <th>Local</th>
                                        <th class="text-right">
                                            Opções
                                        </th>
                                    </tr>
                                </thead>

                                <tbody>
                                    <tr
                                        v-for="(item, index) in paginatedEquipamentosExternos"
                                        :key="equipmentRowKey(item, index, 'external')"
                                    >
                                        <td>
                                            {{ equipmentText(item) }}
                                        </td>

                                        <td>
                                            {{ frenteText(item) }}
                                        </td>

                                        <td>
                                            {{ classeText(item) }}
                                        </td>

                                        <td>
                                            {{ valueOrDash(item.hs) }}
                                        </td>

                                        <td>
                                            {{ valueOrDash(item.ho) }}
                                        </td>

                                        <td>
                                            {{ valueOrDash(item.hp) }}
                                        </td>

                                        <td>
                                            {{ valueOrDash(item.local) }}
                                        </td>

                                        <td class="text-right text-no-wrap">
                                            <v-btn
                                                icon
                                                small
                                                color="primary"
                                                @click="editExternal(index)"
                                            >
                                                <v-icon small>
                                                    mdi-pencil
                                                </v-icon>
                                            </v-btn>

                                            <v-btn
                                                icon
                                                small
                                                color="error"
                                                @click="deleteExternal(index)"
                                            >
                                                <v-icon small>
                                                    mdi-delete
                                                </v-icon>
                                            </v-btn>
                                        </td>
                                    </tr>

                                    <tr
                                        v-if="paginatedEquipamentosExternos.length === 0"
                                    >
                                        <td
                                            colspan="8"
                                            class="text-center grey--text py-6"
                                        >
                                            Sem equipamentos.
                                        </td>
                                    </tr>
                                </tbody>
                            </template>
                        </v-simple-table>

                        <div
                            v-if="equipExternoTotalPages > 1"
                            class="d-flex align-center justify-center py-4"
                        >
                            <v-btn
                                fab
                                x-small
                                color="primary"
                                dark
                                :disabled="equipExternoPage <= 1"
                                @click="equipExternoPage--"
                            >
                                <v-icon small>
                                    mdi-chevron-left
                                </v-icon>
                            </v-btn>

                            <span class="mx-4">
                                {{ equipExternoPage }} /
                                {{ equipExternoTotalPages }}
                            </span>

                            <v-btn
                                fab
                                x-small
                                color="primary"
                                dark
                                :disabled="equipExternoPage >= equipExternoTotalPages"
                                @click="equipExternoPage++"
                            >
                                <v-icon small>
                                    mdi-chevron-right
                                </v-icon>
                            </v-btn>
                        </div>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <!-- ============================================================= -->
        <!-- MODAL                                                         -->
        <!-- ============================================================= -->
        <v-dialog
            v-model="dialog"
            max-width="900"
            persistent
        >
            <v-card>
                <v-card-title class="primary white--text">
                    {{ dialogTitle }}
                </v-card-title>

                <v-card-text class="pt-6">
                    <v-progress-linear
                        v-if="loadingCatalog"
                        class="mb-5"
                        color="primary"
                        indeterminate
                    />

                    <v-alert
                        v-if="dialogError"
                        type="error"
                        dense
                        text
                    >
                        {{ dialogError }}
                    </v-alert>

                    <v-row>
                        <v-col cols="12">
                            <v-autocomplete
                                v-model="draft.equipamento"
                                :items="currentEquipmentCatalog"
                                :item-text="equipmentCatalogText"
                                item-value="Id"
                                label="Equipamento *"
                                outlined
                                dense
                                :loading="loadingCatalog"
                                :disabled="loadingCatalog"
                            />
                        </v-col>

                        <v-col
                            v-if="!hideFrentes"
                            cols="12"
                            md="6"
                        >
                            <v-autocomplete
                                v-model="draft.frente_id"
                                :items="frentes_obra"
                                :item-text="item => item.Descricao"
                                item-value="ID"
                                label="Frente de Obra *"
                                outlined
                                dense
                                @change="onFrenteChange"
                            />
                        </v-col>

                        <v-col
                            v-if="classeNeeded"
                            cols="12"
                            md="6"
                        >
                            <v-autocomplete
                                v-model="draft.classe_id"
                                :items="availableClasses"
                                :item-text="item => item.Descricao"
                                item-value="ID"
                                label="Classe *"
                                outlined
                                dense
                            />
                        </v-col>

                        <v-col
                            cols="12"
                            md="3"
                        >
                            <v-text-field
                                v-model="draft.hs"
                                label="HS / dia"
                                type="number"
                                step="0.01"
                                outlined
                                dense
                            />
                        </v-col>

                        <v-col
                            cols="12"
                            md="3"
                        >
                            <v-text-field
                                v-model="draft.ho"
                                label="HO"
                                type="number"
                                step="0.01"
                                outlined
                                dense
                            />
                        </v-col>

                        <v-col
                            cols="12"
                            md="3"
                        >
                            <v-text-field
                                v-model="draft.hp"
                                label="HP"
                                type="number"
                                step="0.01"
                                outlined
                                dense
                            />
                        </v-col>

                        <v-col
                            cols="12"
                            md="3"
                        >
                            <v-text-field
                                v-model="draft.local"
                                label="Local"
                                outlined
                                dense
                            />
                        </v-col>
                    </v-row>
                </v-card-text>

                <v-card-actions>
                    <v-spacer />

                    <v-btn
                        text
                        @click="closeDialog"
                    >
                        Cancelar
                    </v-btn>

                    <v-btn
                        color="primary"
                        dark
                        :disabled="loadingCatalog"
                        @click="saveLine"
                    >
                        Gravar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import Obra from '@/api/Obra.js'
import Classe from '@/api/Classe.js'
import dayjs from 'dayjs'

export default {
    name: 'Equipments',

    props: {
        fields: {
            type: Object,
            required: true
        },

        frentes_obra: {
            type: Array,
            default: () => []
        },

        hideFrentes: {
            type: Boolean,
            default: false
        },

        template_classes: {
            type: Array,
            default: () => []
        }
    },

    data() {
        return {
            equipamentos: {
                interno: [],
                externo: []
            },

            catalogLoaded: false,
            loadingCatalog: false,
            catalogPromise: null,

            dialog: false,
            dialogType: 'internal',
            editIndex: null,

            draft: {},

            availableClasses: [],
            classeNeeded: false,

            dialogError: null,

            equipInternoPage: 1,
            equipInternoPerPage: 10,

            equipExternoPage: 1,
            equipExternoPerPage: 10
        }
    },

    computed: {
        internalList() {
            return Array.isArray(this.fields.equipamentosInternos)
                ? this.fields.equipamentosInternos
                : []
        },

        externalList() {
            return Array.isArray(this.fields.equipamentosExternos)
                ? this.fields.equipamentosExternos
                : []
        },

        equipInternoTotalPages() {
            return Math.max(
                1,
                Math.ceil(
                    this.internalList.length /
                    this.equipInternoPerPage
                )
            )
        },

        equipExternoTotalPages() {
            return Math.max(
                1,
                Math.ceil(
                    this.externalList.length /
                    this.equipExternoPerPage
                )
            )
        },

        paginatedEquipamentosInternos() {
            const start =
                (this.equipInternoPage - 1) *
                this.equipInternoPerPage

            return this.internalList.slice(
                start,
                start + this.equipInternoPerPage
            )
        },

        paginatedEquipamentosExternos() {
            const start =
                (this.equipExternoPage - 1) *
                this.equipExternoPerPage

            return this.externalList.slice(
                start,
                start + this.equipExternoPerPage
            )
        },

        currentEquipmentCatalog() {
            return this.dialogType === 'internal'
                ? this.equipamentos.interno
                : this.equipamentos.externo
        },

        dialogTitle() {
            const action =
                this.editIndex === null
                    ? 'Adicionar'
                    : 'Editar'

            const type =
                this.dialogType === 'internal'
                    ? 'Equipamento Interno'
                    : 'Equipamento Externo'

            return `${action} ${type}`
        }
    },

    watch: {
        equipInternoTotalPages(value) {
            if (this.equipInternoPage > value) {
                this.equipInternoPage = value
            }
        },

        equipExternoTotalPages(value) {
            if (this.equipExternoPage > value) {
                this.equipExternoPage = value
            }
        }
    },

    mounted() {
        /*
         * Começa a carregar equipamentos em background.
         * Não bloqueia a abertura do template.
         */
        this.preloadCatalog()
    },

    methods: {
        clone(value) {
            return JSON.parse(
                JSON.stringify(value)
            )
        },

        valueOrDash(value) {
            return (
                value === null ||
                value === undefined ||
                value === ''
            )
                ? '-'
                : value
        },

        equipmentRowKey(item, index, type) {
            return (
                item.id ||
                item.ID ||
                item.equipment_id ||
                item.equipamento ||
                `${type}-${index}`
            )
        },

        /*
         * ===============================================================
         * TEXTO EQUIPAMENTO
         * ===============================================================
         */
        equipmentText(item) {
            if (!item) {
                return '-'
            }

            /*
             * Linhas criadas no frontend.
             */
            if (item.codigo) {
                return item.codigo
            }

            /*
             * Linhas que vêm do JOIN Equipamentos no TemplateRoot.
             */
            if (
                item.EntityKey ||
                item.Descricao
            ) {
                const code =
                    item.EntityKey || ''

                const description =
                    item.Descricao || ''

                if (
                    code &&
                    description
                ) {
                    return `${code} - ${description}`
                }

                return (
                    code ||
                    description ||
                    '-'
                )
            }

            if (
                item.equipamento_codigo ||
                item.equipamento_descricao
            ) {
                const code =
                    item.equipamento_codigo || ''

                const description =
                    item.equipamento_descricao || ''

                if (
                    code &&
                    description
                ) {
                    return `${code} - ${description}`
                }

                return (
                    code ||
                    description ||
                    '-'
                )
            }

            return this.valueOrDash(
                item.equipamento ||
                item.equipment_id
            )
        },

        /*
         * ===============================================================
         * TEXTO FRENTE
         * ===============================================================
         */
        frenteText(item) {
            if (!item) {
                return '-'
            }

            if (item.frente_obra) {
                return item.frente_obra
            }

            if (!item.frente_id) {
                return '-'
            }

            const frente =
                this.frentes_obra.find(
                    element =>
                        String(element.ID) ===
                        String(item.frente_id)
                )

            return frente
                ? frente.Descricao
                : item.frente_id
        },

        /*
         * ===============================================================
         * TEXTO CLASSE
         * ===============================================================
         */
        classeText(item) {
            if (!item) {
                return '-'
            }

            if (item.classe_obra) {
                return item.classe_obra
            }

            if (!item.classe_id) {
                return '-'
            }

            if (
                Array.isArray(item.available_classes)
            ) {
                const itemClass =
                    item.available_classes.find(
                        element =>
                            String(element.ID) ===
                            String(item.classe_id)
                    )

                if (itemClass) {
                    return itemClass.Descricao
                }
            }

            const templateClass =
                this.template_classes.find(
                    element =>
                        String(element.ID) ===
                        String(item.classe_id)
                )

            return templateClass
                ? templateClass.Descricao
                : item.classe_id
        },

        /*
         * ===============================================================
         * CATÁLOGO
         * ===============================================================
         */
        equipmentCatalogText(item) {
            if (!item) {
                return ''
            }

            const code =
                item.EntityKey ||
                item.Codigo ||
                ''

            const description =
                item.Descricao ||
                item.Nome ||
                ''

            if (
                code &&
                description
            ) {
                return `${code} - ${description}`
            }

            return code || description
        },

        preloadCatalog() {
            this.ensureCatalog()
                .catch(error => {
                    console.error(
                        'Erro preload equipamentos:',
                        error
                    )
                })
        },

        async ensureCatalog() {
            if (this.catalogLoaded) {
                return this.equipamentos
            }

            if (this.catalogPromise) {
                return this.catalogPromise
            }

            this.loadingCatalog = true

            this.catalogPromise =
                Obra.getObraEquipamentos({
                    work_id:
                        this.fields.obra_id,

                    codigo: null,

                    place:
                        'encarregado'
                })
                    .then(response => {
                        const data =
                            response.data || {}

                        this.equipamentos = {
                            interno:
                                Array.isArray(data.interno)
                                    ? data.interno
                                    : [],

                            externo:
                                Array.isArray(data.externo)
                                    ? data.externo
                                    : []
                        }

                        this.catalogLoaded = true

                        return this.equipamentos
                    })
                    .finally(() => {
                        this.loadingCatalog = false
                        this.catalogPromise = null
                    })

            return this.catalogPromise
        },

        /*
         * ===============================================================
         * MODAL
         * ===============================================================
         */
        async openDialog(
            type,
            index = null
        ) {
            this.dialogType = type
            this.editIndex = index

            this.dialogError = null
            this.availableClasses = []
            this.classeNeeded = false

            const list =
                type === 'internal'
                    ? this.internalList
                    : this.externalList

            const source =
                index === null
                    ? null
                    : list[index]

            this.draft = source
                ? this.normaliseDraft(source)
                : {
                    id:
                        `${dayjs().valueOf()}-new`,

                    equipamento: null,
                    equipment_id: null,

                    frente_id: null,
                    classe_id: null,

                    hs: 0,
                    ho: 0,
                    hp: 0,

                    local: null
                }

            /*
             * Modal abre imediatamente.
             */
            this.dialog = true

            try {
                await this.ensureCatalog()
                await this.prepareClasses()
            } catch (error) {
                console.error(error)

                this.dialogError =
                    'Não foi possível carregar os equipamentos.'
            }
        },

        normaliseDraft(source) {
            const draft =
                this.clone(source)

            draft.equipamento =
                draft.equipamento ||
                draft.equipment_id ||
                null

            draft.equipment_id =
                draft.equipment_id ||
                draft.equipamento ||
                null

            return draft
        },

        closeDialog() {
            this.dialog = false
            this.dialogError = null
        },

        /*
         * ===============================================================
         * FRENTE / CLASSE
         * ===============================================================
         */
        async onFrenteChange() {
            this.$set(
                this.draft,
                'classe_id',
                null
            )

            await this.prepareClasses()
        },

        async prepareClasses() {
            if (this.hideFrentes) {
                this.availableClasses =
                    this.template_classes || []

                this.classeNeeded =
                    this.availableClasses.length > 0

                return
            }

            if (!this.draft.frente_id) {
                this.availableClasses = []
                this.classeNeeded = false

                return
            }

            const frente =
                this.frentes_obra.find(
                    item =>
                        String(item.ID) ===
                        String(this.draft.frente_id)
                )

            if (!frente) {
                this.availableClasses = []
                this.classeNeeded = false

                return
            }

            if (
                Array.isArray(frente.classes) &&
                frente.classes.length > 0
            ) {
                this.availableClasses =
                    frente.classes
            } else {
                const response =
                    await Classe.getClasses({
                        SubEmp:
                            frente.SubEmp
                    })

                this.availableClasses =
                    response.data || []
            }

            this.classeNeeded =
                this.availableClasses.length > 0
        },

        /*
         * ===============================================================
         * GRAVAR LINHA
         * ===============================================================
         */
        saveLine() {
            this.dialogError = null

            if (!this.draft.equipamento) {
                this.dialogError =
                    'Seleciona um equipamento.'

                return
            }

            if (
                !this.hideFrentes &&
                !this.draft.frente_id
            ) {
                this.dialogError =
                    'Seleciona uma frente de obra.'

                return
            }

            if (
                this.classeNeeded &&
                !this.draft.classe_id
            ) {
                this.dialogError =
                    'Seleciona uma classe.'

                return
            }

            const selected =
                this.currentEquipmentCatalog.find(
                    item =>
                        String(item.Id) ===
                        String(
                            this.draft.equipamento
                        )
                )

            const code =
                selected
                    ? (
                        selected.EntityKey ||
                        selected.Codigo ||
                        ''
                    )
                    : (
                        this.draft.EntityKey ||
                        this.draft.equipamento_codigo ||
                        ''
                    )

            const description =
                selected
                    ? (
                        selected.Descricao ||
                        selected.Nome ||
                        ''
                    )
                    : (
                        this.draft.Descricao ||
                        this.draft.equipamento_descricao ||
                        ''
                    )

            const row = {
                ...this.clone(this.draft),

                /*
                 * Campo esperado pelo UpdateJob.
                 */
                equipamento:
                    this.draft.equipamento,

                /*
                 * Campo da tabela.
                 */
                equipment_id:
                    this.draft.equipamento,

                /*
                 * Dados apenas para apresentação imediata.
                 */
                EntityKey:
                    code || null,

                Descricao:
                    description || null,

                equipamento_codigo:
                    code || null,

                equipamento_descricao:
                    description || null,

                codigo:
                    code && description
                        ? `${code} - ${description}`
                        : (
                            code ||
                            description ||
                            null
                        ),

                available_classes:
                    this.clone(
                        this.availableClasses
                    )
            }

            if (
                this.dialogType ===
                'internal'
            ) {
                this.saveInternal(row)
            } else {
                this.saveExternal(row)
            }

            /*
             * Vai para a última página para mostrar
             * imediatamente o equipamento adicionado.
             */
            this.$nextTick(() => {
                if (
                    this.dialogType ===
                    'internal'
                ) {
                    this.equipInternoPage =
                        this.equipInternoTotalPages
                } else {
                    this.equipExternoPage =
                        this.equipExternoTotalPages
                }
            })

            this.closeDialog()
        },

        saveInternal(row) {
            const list =
                [...this.internalList]

            if (this.editIndex === null) {
                list.push(row)
            } else {
                list.splice(
                    this.editIndex,
                    1,
                    row
                )
            }

            /*
             * Vue 2:
             * substituir o array garante a reatividade.
             */
            this.$set(
                this.fields,
                'equipamentosInternos',
                list
            )
        },

        saveExternal(row) {
            const list =
                [...this.externalList]

            if (this.editIndex === null) {
                list.push(row)
            } else {
                list.splice(
                    this.editIndex,
                    1,
                    row
                )
            }

            this.$set(
                this.fields,
                'equipamentosExternos',
                list
            )
        },

        /*
         * ===============================================================
         * EDITAR
         * ===============================================================
         */
        editInternal(pageIndex) {
            this.openDialog(
                'internal',
                this.realInternalIndex(
                    pageIndex
                )
            )
        },

        editExternal(pageIndex) {
            this.openDialog(
                'external',
                this.realExternalIndex(
                    pageIndex
                )
            )
        },

        /*
         * ===============================================================
         * APAGAR
         * ===============================================================
         */
        deleteInternal(pageIndex) {
            const list =
                [...this.internalList]

            list.splice(
                this.realInternalIndex(
                    pageIndex
                ),
                1
            )

            this.$set(
                this.fields,
                'equipamentosInternos',
                list
            )
        },

        deleteExternal(pageIndex) {
            const list =
                [...this.externalList]

            list.splice(
                this.realExternalIndex(
                    pageIndex
                ),
                1
            )

            this.$set(
                this.fields,
                'equipamentosExternos',
                list
            )
        },

        /*
         * ===============================================================
         * PAGINAÇÃO
         * ===============================================================
         */
        realInternalIndex(pageIndex) {
            return (
                (
                    this.equipInternoPage -
                    1
                ) *
                this.equipInternoPerPage
            ) + pageIndex
        },

        realExternalIndex(pageIndex) {
            return (
                (
                    this.equipExternoPage -
                    1
                ) *
                this.equipExternoPerPage
            ) + pageIndex
        }
    }
}
</script>